// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__k7EOW","placeHolderShimmer":"Report_placeHolderShimmer__U1LeC"};